import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class UploadReportsService {
  private url = environment.apiURL;
  constructor(private _http: HttpClienteService, private http: HttpClient) {}

  getReports(name: string) {
    const query = `${this.url}/wcl-customer/reports-path?path=${name}`;
    return this._http.get(query);
  }

  getBlobFilesList(data: { folder: string; subFolder: string }) {
    const query = `${this.url}/wcl-customer/blob-files-list`;
    return this._http.post(query, data);
  }
  loadReports(data: any) {
    const query = `${this.url}/wcl-customer/upload-report`;
    return this._http.post(query, data);
  }
  createPresigned(data: any) {
    const query = `${this.url}/wcl-customer/create-presigned-url`;
    return this._http.post(query, data);
  }
  uploadFileToBlob(preSignedUrl: string, file: File): Observable<any> {
    const headers = new HttpHeaders({
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type || 'application/octet-stream', // Asegura que tenga Content-Type
    });

    console.log('Uploading to:', preSignedUrl);
    console.log('Uploading file:', file.name, 'Size:', file.size);

    return this.http.put(preSignedUrl, file, {
      headers,
      observe: 'response',
    });
  }

  getGeneralReports(type: number) {
    const param = type === 1 ? 'recognition-list' : 'sales-progress-list';
    const query = `${this.url}/wcl-document/${param}`;
    return this._http.get(query);
  }
  deleteGeneralReports(data: any, type: number) {
    const param = type === 1 ? 'recognition-delete' : 'sales-progress-delete';
    const query = `${this.url}/wcl-document/${param}`;
    return this._http.delete(query, { body: data });
  }
  loadGeneralReports(data: any, type: number) {
    const param = type === 1 ? 'upload-recognitions' : 'upload-sales-progress';
    const query = `${this.url}/wcl-document/${param}`;
    return this._http.post(query, data);
  }
  getSalesProgressLogs(id: number) {
    const query = `${this.url}/wcl-document/file-versions?id=${id}`;
    return this._http.get(query);
  }
  loadCustomersClaims(data: any, type: number) {
    const param = type === 1 ? 'upload-customers-products-claims' : 'upload-customers-services-claims';
    const query = `${this.url}/wcl-customer/${param}`;
    return this._http.post(query, data);
  }

  saveCustomerPoints(data: any) {
    const query = `${this.url}/wcl-document/customer-point-save`;
    return this._http.post(query, data);
  }

  getPointList() {
    const query = `${this.url}/wcl-document/point-list`;
    return this._http.get(query);
  }

  saveCustomerRedemptions(data: any) {
    const query = `${this.url}/wcl-document/customer-redemptions`;
    return this._http.post(query, data);
  }

  getRedemptionList() {
    const query = `${this.url}/wcl-document/redemptions-list`;
    return this._http.get(query);
  }

  saveMonthlyPoints(data: any) {
    const query = `${this.url}/wcl-document/monthly-points-save`;
    return this._http.post(query, data);
  }

  getMonthlyPointsList(year?: number) {
    const q = year ? `?year=${year}` : '';
    const query = `${this.url}/wcl-document/monthly-points-list${q}`;
    return this._http.get(query);
  }

  downloadMonthlyPointsFile(id: any) {
    const query = `${this.url}/wcl-document/monthly-points-download?id=${id}`;
    return this._http.get(query);
  }

  getPresignedUrlBlob(data: any) {
    const query = `${this.url}/wcl-document/presigned-url`;
    return this._http.post(query, data);
  }

  saveBlobFiles(data: any) {
    const query = `${this.url}/wcl-customer/blob-files-save`;
    return this._http.post(query, data);
  }

  deleteAllyFile(id: string) {
    const query = `${this.url}/wcl-customer/delete-ally-file?id=${id}`;
    return this._http.delete(query, {});
  }

  downloadFileFromBlob(preSignedUrl: string): Observable<Blob> {
    return this.http.get(preSignedUrl, {
      responseType: 'blob',
    });
  }

  getOrderEarnedPointsSummary(year?: number) {
    const q = year ? `?year=${year}` : '';
    const query = `${this.url}/wcl-document/order-earned-points-summary${q}`;
    return this._http.get(query);
  }

  getOrderEarnedPointsYears() {
    const query = `${this.url}/wcl-document/order-earned-points-years`;
    return this._http.get(query);
  }

  registerOrderEarnedPointsUpload(data: any) {
    const query = `${this.url}/wcl-document/order-earned-points-presigned-download-url`;
    return this._http.post(query, data);
  }

  saveFeaturedPrizes(data: any) {
    const query = `${this.url}/wcl-document/upload-reward-catalog`;
    return this._http.post(query, data);
  }

  getFeaturedPrizesList() {
    const query = `${this.url}/wcl-document/reward-catalog-summary`;
    return this._http.get(query);
  }

  downloadFeaturedPrizes() {
    const query = `${this.url}/wcl-document/reward-download`;
    return this._http.get(query);
  }
}
